export const SET_EBA6_ENABLED = 'SYSTEM.SET_EBA6_ENABLED';
